<template>
  <div style="min-height:320px">
    <img src="../assets/ciman.jpg" style="max-width:70%">
    <div
      v-for="(property, index) in propertiesHL"
      :key="property.id"
      :id="`divHL_${index}`"
      class="w3-margin w3-animate-zoom containerSlides"
      style="display:none;">
      <img
        @click="goToProperty(property.id)"
        :src="property.images.length ? property.images[0].image || '' : ''"
        alt="Lights" class="imageSlide"
      />
      <div class="positionAdress">
        <h2 class="neighborhood">{{property.neighborhood}}</h2>
        <h6 class="town">{{property.town}}</h6>
      </div>
      <h1 class="price">{{formatCurrency(property.price)}}</h1>
      <div class="brief_description">
        <h6>{{property.brief_description}}</h6>
      </div>

      <div class="button-left w3-hover-text-khaki"
        style="height:100%;width:10px;align:center;"
        @click="plusDivs(-1)">
        <div
          class="button-left w3-hover-text-khaki"
          style="vertical-align:middle;">&#10094;</div>
      </div>
      <div class="button-right w3-hover-text-khaki"
        style="height:100%;width:10px;align:center;"
        @click="plusDivs(1)">
        <div
          class="button-right w3-hover-text-khaki"
          style="vertical-align:middle;">&#10095;</div>
      </div>
      <!-- <div class="button-right w3-hover-text-khaki" @click="plusDivs(1)">&#10095;</div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  mounted() {
    this.propertiesHL = this.properties.filter((property) => {
      return property.highlight && !property.sold && property.isVisible;
    });
    this.setSlideShowCount(this.propertiesHL.length);
    this.stopSlides = false;
    this.$nextTick(() => {
      this.carousel();
    });
  },
  beforeDestroy() {
    if (this.timer) clearTimeout(this.timer);
  },
  components: {},
  data() {
    return {
      displayed: 0,
      propertiesHL: [],
      stopSlides: false,
      timer: false,
    };
  },
  computed: {
    ...mapState('properties', ['properties']),
  },
  methods: {
    ...mapMutations('properties', [
      'setSlideShowCount',
    ]),
    formatCurrency(value) {
      return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
    goToProperty(id) {
      this.$router.push(`/property/${id}`);
    },
    carousel(add = 1) {
      if (add && this.displayed >= this.propertiesHL.length - 1) {
        this.displayed = 0;
      } else {
        this.displayed += add;
      }

      if (!add || !this.stopSlides) {
        this.propertiesHL.forEach((property, index) => {
          const div = document.getElementById(`divHL_${index}`);
          if (div) div.style.display = this.displayed === index ? '' : 'none';
        });
      }

      if (!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
          this.carousel(1);
        }, 10000);
      }
    },
    plusDivs(add) {
      if (add > 0) {
        if (this.displayed >= this.propertiesHL.length - 1) {
          this.displayed = 0;
        } else {
          this.displayed += 1;
        }
      } else if (this.displayed < 1) {
        this.displayed = this.propertiesHL.length - 1;
      } else {
        this.displayed -= 1;
      }

      if (this.timer) clearTimeout(this.timer);
      this.stopSlides = true;
      this.carousel(0);
    },
  },
};
</script>

<style>
.button-left {
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(-50%, -50%);
}
.button-right {
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(-50%, -50%);
  cursor: pointer;
}
.containerSlides {
  position: relative;
}
.imageSlide {
  width: calc(100% - 27px);
  margin-right: 15px;
  cursor: pointer;
}

.positionAdress {
  margin: 6px;
  margin-right: 13px;
}
.neighborhood {
  background-color: rgb(233, 92, 10);
  color: white;
}
.town {
  background-color: rgb(233, 92, 10);
  color: white;
}
.price {
  margin: 6px;
  margin-right: 13px;
  background-color: black;
  color: red;
}
.brief_description {
  text-align: center;
  margin: 6px;
  width: calc(100% - 18px);
  bottom: 0%;
  right: 0%;
  background-color: rgb(233, 92, 10);
  color: white;
}

@media (min-width: 650px) and (orientation:landscape) {
  .positionAdress {
  margin-right: 6px;
  position: absolute;
  top: 7%;
  right: 0%;
  transform: translate(-20%, -20%);
}
.neighborhood {
  background-color: rgb(233, 92, 10);
  color: white;
}
.town {
  background-color: rgb(233, 92, 10);
  color: white;
}
.price {
  margin-right: 6px;
  position: absolute;
  top: 41%;
  right: 0%;
  transform: translate(-10%, -20%);
  background-color: black;
  color: red;
}
.brief_description {
  position: absolute;
  text-align: center;
  margin-bottom: 0px;
  width: 280px;
  bottom: 0%;
  right: 0%;
  transform: translate(-10%, -20%);
  background-color: rgb(233, 92, 10);
  color: white;
}
}
</style>
